'use strict';
import '@fancyapps/fancybox';

;(function($) {
    let currentLang = document.documentElement.lang.split('-')[0];

    const initFancyBoxLocalization = function() {
        if (typeof $.fancybox !== 'undefined') {
            $.fancybox.defaults.lang = (typeof currentLang !== 'undefined' && currentLang) ? currentLang : 'en';
        }

        $.fancybox.defaults.buttons = [
            'zoom',
            'slideShow',
            'download',
            'close'
        ];
    };

    $(window).on('load', function () {
        initFancyBoxLocalization();
    });

    // Optional: Customize Fancybox captions or add more functionality
    $(document).on('beforeShow.fb', function (e, instance, slide) {
        // Customize caption formatting if needed
        if (slide.opts.caption) {
            // Modify caption HTML here if required
        }
    });

}($));
